<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="p-3" outlined>
          <v-card-title>
            Allgemein Informationen Bearbeiten
          </v-card-title>
          <v-divider class="mb-3" />
          <v-form class="mt-2" @submit.prevent="save()">
            <v-row>
              <v-col cols="12" lg="4">
                <v-text-field
                  v-model="form.name"
                  outlined
                  label="Name"
                />
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <v-select
                  v-model="form.product_type_id"
                  outlined
                  label="Produkt Art"
                  :items="productData.types"
                  item-text="name"
                  item-value="id"
                />
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <v-select
                  v-model="form.tax_id"
                  outlined
                  label="Steuern"
                  :items="productData.taxes"
                  item-text="name"
                  item-value="id"
                />
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="form.description"
                  label="Beschreibung"
                  outlined
                />
              </v-col>
              <v-col class="d-flex justify-end" cols="12">
                <v-btn type="submit" color="primary">
                  Speichern
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="p-3" cols="12">
        <v-card outlined>
          <v-card-title>
            <v-row>
              <v-col cols="10">
                <v-row>
                  <v-col cols="12" lg="4" class="mt-5">
                    Items Bearbeiten
                  </v-col>
                  <v-col cols="12" lg="8">
                    <v-text-field
                      v-model="search"
                      label="Suche"
                    >
                      <v-icon slot="append">
                        mdi-magnify
                      </v-icon>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-flex justify-end mt-3" cols="2">
                <v-btn
                  color="primary"
                  @click="createItem()"
                >
                  Anlegen
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table
            hide-default-footer
            disable-pagination
            :headers="headers"
            :items="items"
            :search="search"
          >
            <template #[`item.actions`]="{ item }">
              <Inertia-Link :href="route('item.edit', item.id)">
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </Inertia-Link>

              <v-icon @click="deletePrompt(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="createItemPrompt" max-width="800">
      <ItemCreate :product="productData.id" />
    </v-dialog>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          Sind Sie sicher dass dieses Item entfernt werden soll?
        </v-card-title>

        <v-card-text> Item: {{ selectedItem.name }} </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="green darken-1" text @click="dialog = false">
            Disagree
          </v-btn>

          <v-btn color="red darken-1" text @click="softDelete()">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import ItemCreate from '@/Components/Admin/Item/Create'

export default {
   name: 'ProductEdit',
   components: {
      ItemCreate
   },
   metaInfo () {
      return {
         title: this.title ? this.title : `Produkt - ${this.productData.name}`
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      productData: {
         type: Object,
         required: true
      },
      items: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         form: this.$inertia.form({
            name: this.productData.name,
            description: this.productData.description,
            product_type_id: this.productData.type.id,
            tax_id: this.productData.tax.id
         }),
         headers: [
            { text: '#', value: 'id' },
            { text: 'Name', value: 'name' },
            { text: 'Bezeichnung', value: 'label' },
            { text: 'Gruppe', value: 'group_name' },
            { text: 'Hersteller', value: 'supplier' },
            { text: 'Erstellungsdatum', value: 'created_at' },
            { text: '', value: 'actions', sortable: false }
         ],
         selectedItem: {
            name: '',
            id: null
         },
         dialog: false,
         search: null,
         createItemPrompt: false
      }
   },

   methods: {
      save () {
         this.form.patch(this.route('product.update', this.productData.id))
      },
      deletePrompt (item) {
         this.selectedItem = item
         this.dialog = true
      },
      createItem () {
         this.createItemPrompt = true
      },
      softDelete () {
         this.$inertia.patch(this.route('item.soft_destroy', this.selectedItem.id)).then(response => this.dialog = false)
      }
   }
}
</script>

<style></style>
